export default "__VITE_ASSET__CEYJjJCO__"